// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"59addc97","494":"c8caca41"}[chunkId] + ".chunk.css";
};